var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenUpdateLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1753148661514,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2782,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M810.7 597.3a213.3 213.3 0 1 1-213.3 213.3 38.8 38.8 0 1 1 77.6 0 135.8 135.8 0 1 0 135.7-135.7 38.8 38.8 0 0 1 0-77.6z",
    fill: "#2c2c2c",
    "p-id": 2783
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M649.2 600.4l150.5-90.3a21.3 21.3 0 0 1 32.3 18.3V709a21.3 21.3 0 0 1-32.3 18.3L649.2 637a21.3 21.3 0 0 1 0-36.6z",
    fill: "#2c2c2c",
    "p-id": 2784
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M682.7 0a42.7 42.7 0 0 1 25.9 8.8l4.3 3.7L920 219.6a64 64 0 0 1 18.4 39l0.3 6.3v204.4a42.7 42.7 0 0 1-85 5l-0.4-5V273.7L665 85.3H170.7v853.3H512a42.7 42.7 0 0 1 42.4 37.7l0.3 5a42.7 42.7 0 0 1-37.7 42.4l-5 0.3H149.3a64 64 0 0 1-63.7-57.9l-0.3-6.1V64A64 64 0 0 1 143.2 0.3l6.1-0.3h533.4z",
    fill: "#2c2c2c",
    "p-id": 2785
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M298.7 512H512v85.3H298.7z m0-170.7h426.7v85.3H298.7z m0 341.4h170.7V768H298.7z",
    fill: "#2c2c2c",
    "p-id": 2786
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenUpdateLog);
export default __webpack_public_path__ + "static/media/open-update-log.a882837013fcc3eb68bde4c67e87dfba.svg";
export { ForwardRef as ReactComponent };